// extracted by mini-css-extract-plugin
export default {"th":"Table_th__+rntW","control":"Table_control__QTdd9","icon":"Table_icon__m-OGT"};